import React, { useState } from 'react';
import { Grid2 as Grid, Card, CardContent, Container, Divider, Typography, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
export const InstallInfoPage = () => {
  const [open, setOpen] = useState(false);

    const [imgSrc, setImgSrc] = useState(null);

    const handleOpen = (src:any) => {
        setImgSrc(src);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setImgSrc(null);
    };

  return (
  <Container maxWidth="lg" className="mt-5 mt-lg-0">
    <Grid container spacing={2}>
      <Grid size={12}>
          <Dialog open={open} onClose={handleClose} maxWidth="lg">
              <DialogContent sx={{ position: 'relative', p: 2 }}>
                  <IconButton
                      aria-label="close"
                      onClick={handleClose}
                      sx={{ position: 'absolute', top: 8, right: 8 }}
                  >
                      <CloseIcon />
                  </IconButton>
                  {imgSrc && (
                      <img
                          src={imgSrc}
                          alt="Enlarged preview"
                          style={{ width: '100%', height: 'auto', borderRadius: 8 }}
                      />
                  )}
              </DialogContent>
          </Dialog>
          <Card className="bg-light">
          <CardContent>
              <Typography variant="h5" gutterBottom>
              DigitalCNC Install Guidance
              </Typography>
              <Typography variant="body2">Thank you for choosing to install DigitalCNC. Here, you will find workarounds for common issues faced during installation. </Typography>
              <Typography variant="body2">Please note, the installation script should work as intended if you are using NX version 2306 or newer.</Typography>
              <Typography variant="body2">If you find that it does not work (i.e., no user command present, as seen below), then please consult the following information.</Typography>
          </CardContent>
          </Card>
      </Grid>
      <Grid size={12}>
          <Divider />
      </Grid>
      <Grid size={12}>
          <Card className="bg-light">
          <CardContent>
              <Typography variant="h5" gutterBottom>
              DigitalCNC Workflow
              </Typography>
              <Typography variant="body2" color="text.secondary">
                DigitalCNC is a tool for analysing machining toolpaths, providing accurate predictions of machining feedrates and cycle times through analytical and data-driven modelling of CNC machine interpolator dynamics.
                The standard workflow is as follows:
                <ol>
                    <li>Launch DigitalCNC from your CAD/CAM software package (i.e., NX)</li>
                    <li>Import your machining operation information into the tool through selecting a Machine and Surface Finish</li>
                    <li>Run the DigitalCNC Kinematic Analysis</li>
                    <li>Review the predicted cycle times and feed rate fluctuation with given machining operation parameters</li>
                    <li>Repeat Step 1-4 with different Surface Finish and/or Tolerance values, observing your productivity gains with looser tolerances</li>
                </ol>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                After installing DigitalCNC, you should be able to view the following user command:
                <img className="rounded shadow img-fluid m-xl-3 border border-dark"
                     src={ require("../assets/nx-user-command.png") }
                     alt="DigitalCNC command on the NX toolbar"
                     style={{ cursor: 'pointer'}}
                     onClick={() => handleOpen(require('../assets/nx-user-command.png'))}
                />
              </Typography>
          </CardContent>
          </Card>
      </Grid>
      <Grid size={12}>
          <Divider />
      </Grid>
      <Grid size={12}>
        <Card className="bg-light">
          <CardContent>
              <Typography variant="h5" gutterBottom>
              Adding DigitalCNC to the NX Tools Ribbon
              </Typography>
              <Typography variant="body2">
                Should the NX post-installation integration script fail, one can take the following steps to manually add the DigitalCNC button to their workflow.
                <ol className="fancy mt-3">
                    <li>First, right-click on an empty space on Tools ribbon tab to open the context menu. One can then find the "Customize..." menu action.
                    <img className="rounded shadow img-fluid m-xl-3 border border-dark" src={ require("../assets/nx-user-command-add-1.png") } alt="Instruction 1/4 on adding the DigitalCNC command to the NX toolbar"
                         style={{ cursor: 'pointer'}}
                         onClick={() => handleOpen(require('../assets/nx-user-command-add-1.png'))}
                    />
                    </li>
                    <li>The Customize menu allows you to add commands to each ribbon tab. Scroll down on this, and you will find a section identified "My Items", with a "My User Commands" submenu.
                    <img className="rounded shadow img-fluid m-xl-3 border border-dark" src={ require("../assets/nx-user-command-add-2.png") } alt="Instruction 2/4 on adding the DigitalCNC command to the NX toolbar"
                         style={{ cursor: 'pointer'}}
                         onClick={() => handleOpen(require('../assets/nx-user-command-add-2.png'))}
                    />
                    <img className="rounded shadow img-fluid m-xl-3 border border-dark" src={ require("../assets/nx-user-command-add-3.png") } alt="Instruction 3/4 on adding the DigitalCNC command to the NX toolbar"
                         style={{ cursor: 'pointer'}}
                        onClick={() => handleOpen(require('../assets/nx-user-command-add-3.png'))}/>
                    </li>
                    <li>Click on the item denoted "DigitalCNC" and drag this to the leftmost area (or any other empty section) on the Tools ribbon.</li>
                    <li>Once located on the ribbon, you may "Close" the Customize window. Proceed to launch the DigitalCNC tool through selecting an NX Manufacturing "Machining Operation" that contains a generated toolpath.
                    <img className="rounded shadow img-fluid m-xl-3 border border-dark" src={ require("../assets/nx-user-command-add-4.png") } alt="Instruction 4/4 on adding the DigitalCNC command to the NX toolbar"
                         style={{ cursor: 'pointer'}}
                         onClick={() => handleOpen(require('../assets/nx-user-command-add-4.png'))}
                    />
                    </li>
                </ol>
              </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  </Container>
  );
}
